import React, { useEffect, useRef } from 'react';

interface ErrorDisplayProps {
  error: any;
  className?: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, className }) => {
  const errorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (error && errorRef.current) {
      errorRef.current.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'nearest' 
      });
      errorRef.current.focus();
    }
  }, [error]);

  if (!error) return null;

  return (
    <div
      ref={errorRef}
      className={className}
      tabIndex={-1}
      style={{
        backgroundColor: "#f8d7da",
        color: "#721c24",
        padding: "12px",
        border: "1px solid #f5c6cb",
        borderRadius: "4px",
        margin: "16px",
        marginTop: "0"
      }}
    >
      <strong>Error:</strong> {error.message}
    </div>
  );
};

export default ErrorDisplay;